// Components
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@mui/material";

// Types
import { type TFunction, useTranslation } from "src/design-system/core/TranslationContext";
import { MarketingActionVariantEnum } from "src/utils/variants";

interface DeleteScenarioDialogProps {
    isOpen: boolean;
    onCancel: () => void;
    onSave: () => void;
    scenarioId: number;
    t: TFunction;
}

export const DeleteScenarioDialog = ({
    scenarioId,
    isOpen,
    onCancel,
    onSave,
    t,
}: DeleteScenarioDialogProps): JSX.Element => {
    const { translateCommon } = useTranslation();
    return (
        <Dialog
            open={isOpen}
            maxWidth="lg"
            onClose={onCancel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="ranking-compare-method-key-dialog-title">
                {t(`${MarketingActionVariantEnum.SmartScheduler}.scenario-delete-dialog-title`)}
            </DialogTitle>
            <DialogContent>
                <Box marginBottom={1}>
                    <Typography>
                        {t(
                            `${MarketingActionVariantEnum.SmartScheduler}.scenario-delete-dialog-sub-title`,
                            {
                                scenarioId: scenarioId + 1,
                            }
                        )}
                    </Typography>
                </Box>
            </DialogContent>

            <DialogActions>
                <Button onClick={onCancel} color="primary">
                    {translateCommon("actions.cancel")}
                </Button>
                <Button color="primary" onClick={onSave}>
                    {translateCommon("actions.delete")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
